import { BaseAPI } from './BaseAPI.js'
import { ChannelConsumer } from '../types/index.js'

export default class ChannelConsumersAPI extends BaseAPI<ChannelConsumer> {
  override get resource(): string {
    return '/channelConsumers'
  }
}
